<ng-container *transloco="let t">
  <div class="grid w-full grid-cols-1 md:grid-cols-12 md:gap-md">
    @if (offeringQuestionForm) {
      <bgo-dynamic-form
        [dynamicForm]="offeringQuestionForm"
        class="order-2 mt-xl md:order-1 md:col-span-6 md:mt-0 lg:col-span-7 lg:w-2/3"
      ></bgo-dynamic-form>
    }
    @if (isMinimumPriceOffering) {
      <div class="sticky top-22 order-1 sm:top-[120px] md:static md:top-0 md:order-2 md:col-span-6 lg:col-span-5">
        @if (offering) {
          <cft-minimum-price-card
            [offering]="offering"
            [minimumPrice]="offering.fromPrice ?? 0"
            [priceLabel]="t('createJobRequest.minimumPrice.expectedPrice')"
            [infoLabel]="t('createJobRequest.minimumPrice.info')"
          ></cft-minimum-price-card>
        }
      </div>
    }
  </div>
</ng-container>
